import { render } from "./OrganizationRetributionsPodium.vue?vue&type=template&id=f5d93536"
import script from "./OrganizationRetributionsPodium.vue?vue&type=script&lang=js"
export * from "./OrganizationRetributionsPodium.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__